import { render, staticRenderFns } from "./cta-button-cmp-extended.vue?vue&type=template&id=7bc04bd4&scoped=true"
import script from "./cta-button-cmp-extended.vue?vue&type=script&lang=js"
export * from "./cta-button-cmp-extended.vue?vue&type=script&lang=js"
import style0 from "./cta-button-cmp-extended.vue?vue&type=style&index=0&id=7bc04bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc04bd4",
  null
  
)

export default component.exports